export class AcademicYearsResponse {
    ThisAcadYearKey: string;
    NextAcadYearKey: string;
}